import React from "react";
import { Card, CardBody, Row, CardHeader, Col } from "reactstrap";
import { updatePersonAliasNames } from "common/services/persons.service";
import PersonSheetLink from "../PersonSheetLink";
import { ALIAS_SECTIONS } from "../personSheets";

const AliasNames = ({ person }: { person: any }) => {
  const aliasNames = person?.alias || [];

  return (
    <Card>
      <CardHeader className="d-flex align-items-center">
        <div className="text-muted flex-grow-1 d-flex align-items-center">
          <h6 className="mb-0 fw-semibold text-uppercase">Alias Names</h6>
        </div>
        <div className="flex-shrink-0 d-flex align-items-center">
          <PersonSheetLink
            person={person}
            title="Alias names"
            sections={ALIAS_SECTIONS}
            action="updateAliasNames"
            save={updatePersonAliasNames}
            savedMessage="Alias names saved"
          />
        </div>
      </CardHeader>

      <CardBody className="card-body ">
        <Row className="g-3">
          <Col md={12}>
            <p className="fw-semibold text-body mb-1">
              {aliasNames.map((el: any) => el.name).join(", ")}
            </p>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default AliasNames;
